var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as fromState from '../states/country-state.state';
import * as fromActions from '../actions/country-state.actions';
import { COUNTRIES_TRANSLATION_KEY } from '@ibe.config';
var initialState = fromState.initialState;
/** mappers */
var mapUSStatesCodesOptions = function (states) {
    return states.map(function (state) { return ({ text: state.state, value: state.code }); });
};
var ɵ0 = mapUSStatesCodesOptions;
var mapCountryConversionCodesOptions = function (countries) {
    return countries.map(function (country) { return ({ text: country.country, value: country.alpha_2_code }); });
};
var ɵ1 = mapCountryConversionCodesOptions;
var mapCountryCodesPrefixOptions = function (countries) {
    return countries.map(function (country) { return ({ text: COUNTRIES_TRANSLATION_KEY + country.code.toLowerCase(), value: country.prefix }); });
};
var ɵ2 = mapCountryCodesPrefixOptions;
var mapCountryCodesOptions = function (countries) {
    return countries.map(function (country) { return ({ text: COUNTRIES_TRANSLATION_KEY + country.code.toLowerCase(), value: country.code }); });
};
var ɵ3 = mapCountryCodesOptions;
/** getters */
export var getCountryCodes = function (state) { return state.countryCodes; };
export var getCountryCodesPrefixOpts = function (state) { return state.countryCodesPrefixOpts; };
export var getCountryCodesOpts = function (state) { return state.countryCodesOpts; };
export var getCountryConversionCodes = function (state) { return state.countryConversionCodes; };
export var getCountryConversionCodesOpts = function (state) { return state.countryConversionCodesOpts; };
export var getUSAirports = function (state) { return state.USAirports; };
export var getUSStates = function (state) { return state.USStates; };
export var getSchengenCountryCodes = function (state) { return state.schengenCountryCodes; };
export var getEUCountryCodes = function (state) { return state.euCountryCodes; };
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case fromActions.ActionTypes.LOAD_COUNTRY_CODES_SUCCESS: {
            var countryCodesPrefix = mapCountryCodesPrefixOptions(action.payload);
            var countryCodesOpts = mapCountryCodesOptions(action.payload);
            return __assign({}, state, { countryCodes: action.payload, countryCodesPrefixOpts: countryCodesPrefix, countryCodesOpts: countryCodesOpts });
        }
        case fromActions.ActionTypes.LOAD_COUNTRY_CONVERSION_CODES_SUCCESS: {
            var countries = mapCountryConversionCodesOptions(action.payload);
            return __assign({}, state, { countryConversionCodes: action.payload, countryConversionCodesOpts: countries });
        }
        case fromActions.ActionTypes.LOAD_US_AIRPORTS_SUCCESS: {
            return __assign({}, state, { USAirports: action.payload });
        }
        case fromActions.ActionTypes.LOAD_US_STATES_SUCCESS: {
            var states = mapUSStatesCodesOptions(action.payload);
            return __assign({}, state, { USStates: states });
        }
        case fromActions.ActionTypes.LOAD_SCHENGEN_COUNTRY_CODES_SUCCESS: {
            return __assign({}, state, { schengenCountryCodes: action.payload });
        }
        case fromActions.ActionTypes.LOAD_EU_COUNTRY_CODES_SUCCESS: {
            return __assign({}, state, { euCountryCodes: action.payload });
        }
        default:
            return state;
    }
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
